import React from 'react';
import './BookingSummary.css';

function BookingSummary({ data }) {
  return (
    <div className="booking-summary">
      <h3 className="summary-title">Resumen de tu Reserva</h3>
      <div className="summary-item">
        <span className="summary-key">Sede:</span>
        <span className="summary-value">{data.sede || 'No seleccionada'}</span>
      </div>
      <div className="summary-item">
        <span className="summary-key">Fecha:</span>
        <span className="summary-value">{data.date || 'No seleccionada'}</span>
      </div>
      <div className="summary-item">
        <span className="summary-key">Hora:</span>
        <span className="summary-value">{data.time || 'No seleccionada'}</span>
      </div>
      <div className="summary-item">
        <span className="summary-key">Personas:</span>
        <span className="summary-value">{data.people || 'No especificado'}</span>
      </div>
      <div className="summary-item">
        <span className="summary-key">Nombre:</span>
        <span className="summary-value">{data.name || 'No ingresado'}</span>
      </div>
      <div className="summary-item">
        <span className="summary-key">Email:</span>
        <span className="summary-value">{data.email || 'No ingresado'}</span>
      </div>
      <div className="summary-item">
        <span className="summary-key">Teléfono:</span>
        <span className="summary-value">{data.phone || 'No ingresado'}</span>
      </div>
    </div>
  );
}

export default BookingSummary;
